import React from 'react';
import Footer from 'src/components/page/Footer';
import Header from 'src/components/page/Header';

interface SiteLayoutContextValue {
    Header: React.ComponentType<any>;
    Footer: React.ComponentType<any>;
    showVolumeDiscount: boolean;
    showCredits: boolean;
    SidebarLogo: React.ComponentType<any>;
    allowedAccountRoutePaths?: readonly string[];
    allowedDataTabPaths?: readonly string[];
}

const DefaultSidebarLogo: React.FC = () => <img src={'/favicon.ico'} alt="" />;

export const SiteLayoutContext = React.createContext<SiteLayoutContextValue>({
    Header,
    Footer,
    showVolumeDiscount: true,
    showCredits: true,
    SidebarLogo: DefaultSidebarLogo,
});
